import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportInventoryStockFilters, getReportInventoryStockAction } from "redux/actions/Reports/reportInventoryStock/reportInventoryStockActions";
import { useSearch } from "hooks/useSearch";
import { MAX_DATE_RANGE_DAYS } from "helpers/dictionary";

export const ReportInventoryStockView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportInventoryStock);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, MAX_DATE_RANGE_DAYS, setSnackbar)) return;
    dispatch(getReportInventoryStockAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte de Existencias de Inventario" icon={<AssessmentIcon />}>
      {isLoadingComp?.loadingInventoryStock
        ? <LoadingComponent />
        : <TableInputs
            reducer="reportInventoryStock"
            dates
            stations
            maxDate={newDate()}
            dispatchAction={setReportInventoryStockFilters}
            submitAction={handleSubmit}
            submitSecond={(e) => handleSubmit(e, false)}
            submitButtonName="PDF"
          />
      }
    </GlobalBox>
  );
};
